module.exports = __webpack_public_path__ + "static/img/no_data.4beecc90.png";